module.exports = __webpack_public_path__ + "media/NewsCenterDetails7_video.84a078b0.mp4";